module.exports = __webpack_public_path__ + "img/3_003.68aedf2e.webp";